import axios from "axios";
import { isIndia } from "@/lib/edition";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ga_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (isIndia) config.headers["X-Edition"] = "india";
  return config;
});

export function fileUrl(fileId) {
  if (!fileId) return null;
  if (typeof fileId === "string" && /^(https?:)?\/\//.test(fileId)) return fileId;
  return `${API}/files/${fileId}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
